import { render, staticRenderFns } from "./PDPProductName.vue?vue&type=template&id=1d491fea&scoped=true"
import script from "./PDPProductName.vue?vue&type=script&lang=js"
export * from "./PDPProductName.vue?vue&type=script&lang=js"
import style0 from "./PDPProductName.vue?vue&type=style&index=0&id=1d491fea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d491fea",
  null
  
)

export default component.exports